import React from "react"

import { Divider as MuiDivider, Grid, Typography } from "@material-ui/core"

import useStyles from "@/pages/Admin/WABAUsageStatement/components/CustomChartTooltip/styles"
import { ChartTooltipProps } from "@/protocols/wabaUsageStatement"

const CustomChartTooltip: React.FC<ChartTooltipProps> = (props) => {
	const { active, payload, label } = props
	const classes = useStyles()
	const isVisible = active === true && (payload?.length ?? 0) > 0
	if (!isVisible) {
		return null
	}
	const data = payload[0].payload
	return (
		<Grid container direction="column" className={classes.container}>
			<Grid item>
				<Typography variant="subtitle2" className={classes.label}>
					{label}
				</Typography>
			</Grid>
			<Grid item>
				<MuiDivider />
			</Grid>
			<Grid item>
				<Grid container alignItems="center" spacing={1}>
					<Grid item>
						<div className={classes.purpleDot} />
					</Grid>
					<Grid item>
						<Typography variant="caption" className={classes.entryText}>
							Custo: <strong>${data.cost ?? 0}</strong>
						</Typography>
					</Grid>
				</Grid>
			</Grid>
			<Grid item>
				<Grid container alignItems="center" spacing={1}>
					<Grid item>
						<div className={classes.grayDot} />
					</Grid>
					<Grid item>
						<Typography variant="caption" className={classes.entryText}>
							Mensagens: <strong>{data.totalMsg}</strong>
						</Typography>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	)
}

export default CustomChartTooltip
